import SideBarButton from "./SideBarButton";
import { navigateTo } from "context/navigation.service";
import { useDataStore } from "@store/user_org";
import { isGUEST } from "@helpers/accessHelpers";
import { isOwnerOrAdmin, useSimulateMemberView } from "@utils/permissions";

export default function SettingBar({
  page,
  setPage,
}: {
  page: string;
  setPage: (page: string) => void;
}) {
  const userData = useDataStore((state) => state.userData);
  const isGuest = isGUEST(userData);
  const isAdmin = userData?.config?.admin === true;
  useSimulateMemberView();
  const isManager = isOwnerOrAdmin(userData);

  return (
    <div className="w-64 min-w-64 h-screen justify-start pt-10 pl-2 border-r-1 flex flex-col">
      <div className="flex flex-col pl-2">
        <div className="ml-3 font-semibold text-hx">Paramètres</div>
        <div className="flex flex-col mt-6 mr-6">
          <SideBarButton
            label="Compte"
            name="user"
            highlighted={page === "account"}
            onClick={() => navigateTo({ route: "/settings?page=account" })}
          />
          {!isGuest && (
            <>
              {isManager && (
                <SideBarButton
                  label="Entreprise"
                  name="business"
                  highlighted={page === "company"}
                  onClick={() => navigateTo({ route: "/settings?page=company" })}
                />
              )}
              <SideBarButton
                label="Equipe"
                name="users"
                highlighted={page === "team"}
                onClick={() => navigateTo({ route: "/settings?page=team" })}
              />
              <SideBarButton
                label="Dispo atelier"
                name="sett-dispo"
                highlighted={page === "dispo-atelier" || page === "disponibilites" || page === "service-rapide"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=dispo-atelier" })
                }
              />
              <SideBarButton
                label="Réceptions"
                name="side-reception"
                highlighted={page === "receptions"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=receptions" })
                }
              />
              <SideBarButton
                label="Prise de RDV"
                name="sett-rdv"
                highlighted={page === "prise-rdv"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=prise-rdv" })
                }
              />
              <SideBarButton
                label="Interventions"
                name="sett-interventions"
                highlighted={page === "interventions"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=interventions" })
                }
              />
              <SideBarButton
                label="Tags"
                name="tag"
                highlighted={page === "tags"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=tags" })
                }
              />
              <SideBarButton
                label="Avis clients"
                name="star"
                highlighted={page === "avis"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=avis" })
                }
              />
              <SideBarButton
                label="Signatures"
                name="sett-sign"
                highlighted={page === "signatures"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=signatures" })
                }
              />
              <SideBarButton
                label="Rappels devis"
                name="cloche"
                highlighted={page === "devis-reminders"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=devis-reminders" })
                }
              />
              {isManager && (
                <SideBarButton
                  label="Paiements"
                  name="sett-payments"
                  highlighted={page === "paiements"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=paiements" })
                  }
                />
              )}
<SideBarButton
                label="Notifications"
                name="cloche"
                highlighted={page === "notifications"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=notifications" })
                }
              />
              {isManager && (
                <>
                  <SideBarButton
                    label="ServiceBox"
                    name="sett-servicebox"
                    highlighted={page === "servicebox"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=servicebox" })
                    }
                  />
                  <SideBarButton
                    label="Sync ServiceBox"
                    name="sett-servicebox"
                    highlighted={page === "servicebox-sync"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=servicebox-sync" })
                    }
                  />
                  <SideBarButton
                    label="Téléphonie 3CX"
                    name="phone"
                    highlighted={page === "threecx"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=threecx" })
                    }
                  />
                  <SideBarButton
                    label="Facturation"
                    name="facturation"
                    highlighted={page === "facturation" || page === "messagerie"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=facturation" })
                    }
                  />
                  <SideBarButton
                    label="Stockage"
                    name="storage"
                    highlighted={page === "stockage"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=stockage" })
                    }
                  />
                </>
              )}
              {/* <SideBarButton
                label="Modèles emails"
                name="email"
                highlighted={page === "email-templates"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=email-templates" })
                }
              /> */}
              {isAdmin && (
                <>
                  <SideBarButton
                    label="Utilisateurs"
                    name="users"
                    highlighted={page === "users"}
                    onClick={() => navigateTo({ route: "/settings?page=users" })}
                  />
                  <SideBarButton
                    label="Proxys"
                    name="sett-servicebox"
                    highlighted={page === "proxy-dashboard"}
                    onClick={() => navigateTo({ route: "/settings?page=proxy-dashboard" })}
                  />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
